<template>
	<div class="layout-footer" >
        <p>© Place Must~Go by Thai Digital Map Co.,Ltd.</p>
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

</style>
